import { Link } from "react-router-dom";
import LegalShell, { Section } from "@/components/public/LegalShell";
import { useLang } from "@/i18n/LanguageContext";
import { LifeBuoy, MessageCircle, Store, CreditCard, Tablet, BookOpen } from "lucide-react";

const faqIcons = [Store, CreditCard, Tablet, BookOpen];

export default function Soporte() {
  const { t } = useLang();
  const S = t.support;
  return (
    <LegalShell testid="page-soporte" eyebrow={S.eyebrow} title={S.title} intro={S.intro}>
      <div className="grid sm:grid-cols-2 gap-6 mb-12">
        <div className="rounded-2xl border border-border p-6">
          <LifeBuoy className="w-7 h-7 text-foreground mb-3" />
          <h3 className="font-admin font-bold text-lg mb-1">{S.emailCard.title}</h3>
          <p className="text-sm text-muted-foreground mb-3">{S.emailCard.desc}</p>
          <a href={`mailto:${S.emailCard.value}`} className="text-sm font-bold text-foreground" data-testid="support-email">{S.emailCard.value}</a>
        </div>
        <div className="rounded-2xl border border-border p-6">
          <MessageCircle className="w-7 h-7 text-foreground mb-3" />
          <h3 className="font-admin font-bold text-lg mb-1">{S.contactCard.title}</h3>
          <p className="text-sm text-muted-foreground mb-3">{S.contactCard.desc}</p>
          <Link to="/contacto" className="text-sm font-bold text-foreground" data-testid="support-contact-link">{S.contactCard.link}</Link>
        </div>
      </div>

      <Section title={S.faqTitle}>
        <div className="space-y-5 not-prose">
          {S.faqs.map((f, i) => {
            const Icon = faqIcons[i] || Store;
            return (
              <div key={f.q} className="flex gap-4 rounded-xl border border-border p-5">
                <Icon className="w-5 h-5 text-foreground flex-shrink-0 mt-0.5" />
                <div>
                  <div className="font-bold text-foreground">{f.q}</div>
                  <p className="text-sm text-muted-foreground mt-1">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </LegalShell>
  );
}
